<script setup lang="ts">
import { autoUpdate, useFloating } from '@floating-ui/vue';

const { reference, open } = defineProps<{
  reference: HTMLElement | null;
  open: boolean;
}>();
defineEmits<{ close: [] }>();

const burgerMenu = useTemplateRef('burgerMenu_ref');
const { floatingStyles } = useFloating(
  computed(() => reference),
  burgerMenu,
  {
    open: computed(() => open),
    strategy: 'fixed',
    placement: 'bottom-start',
    whileElementsMounted: autoUpdate,
  },
);
const { height: referenceHeight } = useElementSize(computed(() => reference));
</script>

<template>
  <div
    ref="burgerMenu_ref"
    :style="{ ...floatingStyles, height: `calc(100% - ${referenceHeight}px)` }"
    class="pointer-events-none relative isolate size-full *:pointer-events-auto"
  >
    <Transition enter-from-class="opacity-0" leave-to-class="opacity-0">
      <PageContainerAlignment
        v-if="open"
        class="bg-client-white fixed inset-0 z-20 h-screen transition duration-300 ease-in-out"
      >
        <NavbarBurgerLinks @close-burger="$emit('close')" />
      </PageContainerAlignment>
    </Transition>
  </div>
</template>
